import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { url } from '../config';
import { eventActions, saveAllEvents, saveFutureEvents } from '../actions/eventAction';

function getAllEvents() {
  return axios.get(url + '/api/event/event/');
}

function* getAllEventsResponse(action) {
  if (action !== undefined) {
    try {
      const response = yield call(getAllEvents);
      const { data } = response;
      yield put(saveAllEvents(data));
    } catch (e) {
      console.log(e);
    }
  }
}

function getFutureEvents() {
  return axios.get(url + '/api/event/future-events/');
}

function* getFutureEventsResponse(action) {
  if (action !== undefined) {
    try {
      const response = yield call(getFutureEvents);
      const { data } = response;
      yield put(saveFutureEvents(data));
    } catch (e) {
      console.log(e);
    }
  }
}

function createEvent(formData) {
  return axios.post(url + '/api/event/event/', formData);
}

function* createEventResponse(action) {
  if (action !== undefined) {
    try {
      const response = yield call(createEvent, action.formData);

      if (response.status >= 200 && response.status < 300) {
        alert('Event has been created successfully');
        window.location.assign('/');
      } else {
        alert(
          `Event has not been created. Status code: ${response.status}. Please check that you provided all the necessary data and try again`
        );
      }
    } catch (e) {
      console.log(e);
      alert('An error occurred while creating the event. Please try again.');
    }
  }
}

function editEvent(formData, id) {
  return axios.put(url + `/api/event/event/${id}/`, formData);
}

function* editEventResponse(action) {
  if (action !== undefined) {
    try {
      const response = yield call(editEvent, action.formData, action.id);

      if (response.status >= 200 && response.status < 300) {
        alert(`Event ${action.formData.title} has been updated successfully`);
        window.location.assign('/');
      } else {
        alert(
          `Event has not been updated. Status code: ${response.status}. Please check that you provided all the necessary data and try again`
        );
      }
    } catch (e) {
      console.log(e);
      alert('An error occurred while updating the event. Please try again.');
    }
  }
}

function* eventAPI() {
  yield takeEvery(eventActions.GET_ALL_EVENTS, getAllEventsResponse);
  yield takeEvery(eventActions.GET_FUTURE_EVENTS, getFutureEventsResponse);
  yield takeEvery(eventActions.CREATE_EVENT, createEventResponse);
  yield takeEvery(eventActions.EDIT_EVENT, editEventResponse);
}
export default eventAPI;
